import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {counterOperation} from '../../util/uiconstants';

const documentGlAccountUploadCountReducer = (state = initialstate.glAccountDocUploadCount, action) => {
	switch (action.type) {
		case actions.UPDATE_GLACCOUNT_DOCUPLOAD_COUNT:
			switch (action.payload) {
				case counterOperation.increment:
					return state + 1;
				case counterOperation.decrement:
					return state > 0 ? state - 1 : 0;
				case counterOperation.reset:
					return 0;
				default:
					return state;
			}
		default:
			return state;
	}
};

export default documentGlAccountUploadCountReducer;
